import React from 'react';
import { Link } from 'react-router-dom';
import PROMOTIONALEN from "../../../assets/images/promotional_en.png";
import PROMOTIONALSO from "../../../assets/images/promotional_so.png";
import { getlanguage } from "../../../helpers/changelanguage";
import './Addbox.css';

export default () => { 
    let  language = getlanguage();
    return (
        <div className="ad_box">
            <a href="https://www.baaldahab.com/" target="_blank"><img src={(language == 'en') ? '/assets/images/promotional_en.png' : '/assets/images/promotional_so.png' } /></a>
        </div>
    );
};